import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { addAccount } from '@popup/steem/actions/account.actions';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
const SelectKeys = ({ keys, username, addAccount, setErrorMessage, setTitleContainerProperties, }) => {
    const [importActive, setImportActive] = useState(keys.active ? true : false);
    const [importPosting, setImportPosting] = useState(keys.posting ? true : false);
    const [importMemo, setImportMemo] = useState(keys.memo ? true : false);
    const [importActivehive, setImportActivehive] = useState(keys.activehive ? true : false);
    const [importPostinghive, setImportPostinghive] = useState(keys.postinghive ? true : false);
    const [importMemohive, setImportMemohive] = useState(keys.memohive ? true : false);
    const [importActiveblurt, setImportActiveblurt] = useState(keys.activeblurt ? true : false);
    const [importPostingblurt, setImportPostingblurt] = useState(keys.postingblurt ? true : false);
    const [importMemoblurt, setImportMemoblurt] = useState(keys.memoblurt ? true : false);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_import_keys',
            isBackButtonEnabled: true,
        });
    });
    const importKeys = () => {
        let keysToImport = {};
        if (importActive) {
            keysToImport.active = keys.active;
            keysToImport.activePubkey = keys.activePubkey;
        }
        if (importPosting) {
            keysToImport.posting = keys.posting;
            keysToImport.postingPubkey = keys.postingPubkey;
        }
        if (importMemo) {
            keysToImport.memo = keys.memo;
            keysToImport.memoPubkey = keys.memoPubkey;
        }
        if (importActivehive) {
            keysToImport.activehive = keys.activehive;
            keysToImport.activePubkeyhive = keys.activePubkeyhive;
        }
        if (importPostinghive) {
            keysToImport.postinghive = keys.postinghive;
            keysToImport.postingPubkeyhive = keys.postingPubkeyhive;
        }
        if (importMemohive) {
            keysToImport.memohive = keys.memohive;
            keysToImport.memoPubkeyhive = keys.memoPubkeyhive;
        }
        if (importActiveblurt) {
            keysToImport.activeblurt = keys.activeblurt;
            keysToImport.activePubkeyblurt = keys.activePubkeyblurt;
        }
        if (importPostingblurt) {
            keysToImport.postingblurt = keys.postingblurt;
            keysToImport.postingPubkeyblurt = keys.postingPubkeyblurt;
        }
        if (importMemoblurt) {
            keysToImport.memoblurt = keys.memoblurt;
            keysToImport.memoPubkeyblurt = keys.memoPubkeyblurt;
        }
        if (!KeysUtils.hasKeys(keysToImport)) {
            setErrorMessage('popup_accounts_no_key_selected');
        }
        else {
            addAccount({ name: username, keys: keysToImport });
        }
    };
    return (React.createElement("div", { className: "select-keys-page", "data-testid": `${Screen.ACCOUNT_PAGE_SELECT_KEYS}-page` },
        React.createElement("div", { "data-testid": "select-keys-page-caption", className: "caption", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_import_success'),
            } }),
        React.createElement("div", { className: "key-group" },
            React.createElement("div", { className: "chain-label" }, "Steem"),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-posting-key", title: "popup_html_posting", checked: importPosting, onChange: setImportPosting, disabled: !keys.posting, tooltipMessage: !keys.posting ? 'popup_html_public_key_not_matching' : undefined }),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-active-key", title: "popup_html_active", checked: importActive, onChange: setImportActive, disabled: !keys.active, tooltipMessage: !keys.active ? 'popup_html_public_key_not_matching' : undefined }),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-memo-key", title: "popup_html_memo", checked: importMemo, onChange: setImportMemo, disabled: !keys.memo, tooltipMessage: !keys.memo ? 'popup_html_public_key_not_matching' : undefined })),
        React.createElement("div", { className: "key-group" },
            React.createElement("div", { className: "chain-label hive" }, "Hive"),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-posting-key-hive", title: "popup_html_posting", checked: importPostinghive, onChange: setImportPostinghive, disabled: !keys.postinghive, tooltipMessage: !keys.postinghive ? 'popup_html_public_key_not_matching' : undefined }),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-active-key-hive", title: "popup_html_active", checked: importActivehive, onChange: setImportActivehive, disabled: !keys.activehive, tooltipMessage: !keys.activehive ? 'popup_html_public_key_not_matching' : undefined }),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-memo-key-hive", title: "popup_html_memo", checked: importMemohive, onChange: setImportMemohive, disabled: !keys.memohive, tooltipMessage: !keys.memohive ? 'popup_html_public_key_not_matching' : undefined })),
        React.createElement("div", { className: "key-group" },
            React.createElement("div", { className: "chain-label blurt" }, "Blurt"),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-posting-key-blurt", title: "popup_html_posting", checked: importPostingblurt, onChange: setImportPostingblurt, disabled: !keys.postingblurt, tooltipMessage: !keys.postingblurt ? 'popup_html_public_key_not_matching' : undefined }),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-active-key-blurt", title: "popup_html_active", checked: importActiveblurt, onChange: setImportActiveblurt, disabled: !keys.activeblurt, tooltipMessage: !keys.activeblurt ? 'popup_html_public_key_not_matching' : undefined }),
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-import-memo-key-blurt", title: "popup_html_memo", checked: importMemoblurt, onChange: setImportMemoblurt, disabled: !keys.memoblurt, tooltipMessage: !keys.memoblurt ? 'popup_html_public_key_not_matching' : undefined })),
        React.createElement("div", { className: "fill-space" }),
        React.createElement(ButtonComponent, { dataTestId: "button-save", label: "popup_html_save", onClick: () => importKeys() })));
};
const mapStateToProps = (state) => {
    return {
        keys: state.navigation.stack[0].params.keys,
        username: state.navigation.stack[0].params.username,
    };
};
const connector = connect(mapStateToProps, {
    setErrorMessage,
    addAccount,
    setTitleContainerProperties,
});
export const SelectKeysComponent = connector(SelectKeys);
